var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgErrorIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "14px",
    height: "14px",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "731616F0-012B-4E55-A306-8C284F922D9B") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.6 C8.76862711,0.6 10.2774333,1.22597183 11.5264637,2.47793427 C12.7754941,3.72989671 13.4,5.23723688 13.4,7 C13.4,8.76276312 12.7754941,10.2701033 11.5264637,11.5220657 C10.2774333,12.7740282 8.76862711,13.4 7,13.4 C5.23137289,13.4 3.72256674,12.7740282 2.4735363,11.5220657 C1.22450585,10.2701033 0.6,8.76276312 0.6,7 C0.6,5.23723688 1.21950981,3.73490449 2.45854801,2.49295775 C3.7175707,1.23097961 5.23137289,0.6 7,0.6 Z M8.66175439,4.44 L6.98502924,6.09647059 L5.33824561,4.44 L4.44,5.34352941 L6.08678363,7 L4.44,8.65647059 L5.33824561,9.56 L6.98502924,7.90352941 L8.66175439,9.56 L9.56,8.65647059 L7.88327485,7 L9.56,5.34352941 L8.66175439,4.44 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TurnItBlue---Design",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.1_Signin_06",
    transform: "translate(-810.000000, -402.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-6",
    transform: "translate(693.000000, 263.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2",
    transform: "translate(48.000000, 42.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Block-/-Form-/-Center",
    transform: "translate(49.000000, 84.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF17-Content",
    transform: "translate(20.000000, 11.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\uD83C\\uDF10-Icon-Left",
    transform: "translate(0.000000, 2.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "ic_error_circle_filled",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Color",
    mask: "url(#mask-2)",
    fill: "#D35E67"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1.000000, -1.000000)",
    id: "\\u25A0-Color"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }))))))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorIcon);
export default __webpack_public_path__ + "static/media/ErrorIcon.cb7384bfa1d71cc22ed6b38c52e84c6f.svg";
export { ForwardRef as ReactComponent };